/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Part_1_TInputs */

const en_tut_part_1_t = /** @type {(inputs: Tut_Part_1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting from zero`)
};

const id_tut_part_1_t = /** @type {(inputs: Tut_Part_1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai dari nol`)
};

/**
* | output |
* | --- |
* | "Starting from zero" |
*
* @param {Tut_Part_1_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_part_1_t = /** @type {((inputs?: Tut_Part_1_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Part_1_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_part_1_t(inputs)
	return en_tut_part_1_t(inputs)
});